import React from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { client } from './apollo/config';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'connected-react-router';
import AppLayout from '@crema/core/AppLayout';
import AuthRoutes from '@crema/utility/AuthRoutes';
import LocaleProvider from '@crema/utility/LocaleProvider';
import CremaThemeProvider from '@crema/utility/CremaThemeProvider';
import CremaStyleProvider from '@crema/utility/CremaStyleProvider';
import ContextProvider from '@crema/utility/ContextProvider';
import configureStore, {history} from './redux/store';
import CssBaseline from '@material-ui/core/CssBaseline';
import Web3Provider from 'modules/auth/Web3Provider';
import SnackbarProvider from './@crema/components/StackbarProvider';

const ConnectedRouterAny = ConnectedRouter as any;
const store = configureStore();

const App = () => (
    <ContextProvider>
      <ApolloProvider client={client}>
      <Provider store={store}>
        <CremaThemeProvider>
          <CremaStyleProvider>
            <SnackbarProvider>
              <LocaleProvider>
                <ConnectedRouterAny history={history}>
                  <AuthRoutes>
                    <CssBaseline />
                    <AppLayout />
                    <Web3Provider />
                  </AuthRoutes>
                </ConnectedRouterAny>
              </LocaleProvider>
            </SnackbarProvider>
          </CremaStyleProvider>
        </CremaThemeProvider>
      </Provider>
      </ApolloProvider>
    </ContextProvider>
);

export default App;
